import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModalSelecionarFiltrosPage } from './modal-selecionar-filtros.page';

const routes: Routes = [
  {
    path: '',
    component: ModalSelecionarFiltrosPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalSelecionarFiltrosPageRoutingModule {}
